import type { FeedbackMessages } from './en';

const fi: FeedbackMessages = {
  qualified: {
    title: 'Kiitos, että osallistuit tähän tutkimukseen!',
    body1: 'Voit nyt sulkea selainikkunan.',
    body2: 'Toivomme näkevämme sinut pian uudelleen.',
    refCode: 'Viitekoodi: {code}',
  },
  quotaFull: {
    title: 'Tämä tutkimus on suljettu',
    body1: 'Kiitos kiinnostuksestasi tutkimustamme kohtaan.',
    body2: 'Olemme valitettavasti saaneet kaikki tarvitsemamme vastaukset.',
    body3: 'Toivomme näkevämme sinut jossakin tulevassa tutkimuksessamme!',
    refCode: 'Viitekoodi: {code}',
  },
  terminated: {
    title: 'Kiitos palautteestasi!',
    body1:
      'Toivomme näkevämme sinut pian tulevissa tutkimuksissamme. Siihen asti toivotamme sinulle mukavaa päivänjatkoa.',
    body2: 'Sulje tämä selainikkuna.',
    refCode: 'Viitekoodi: {code}',
  },
  mismatch: {
    title: 'Kiitos kiinnostuksestasi',
    body1: 'Et valitettavasti kuulu tämän tutkimuksen kohderyhmään.',
    body2: 'Voit sulkea tämän sivun.',
    code: 'Koodi: {code}',
  },
  error: {
    title: 'Emme voi käsitellä pyyntöäsi',
    linkProblemDetailed:
      'Seuraamassasi linkissä on ongelmia. Tarkista, että osoiterivin linkki vastaa sinulle annettua linkkiä, ja yritä uudelleen.',
    linkProblemGeneric:
      'Seuraamassasi linkissä on ongelmia. Yritä ystävällisesti uudelleen.',
    contactPerson:
      'Jos ongelma jatkuu, ilmoita asiasta henkilölle, jolta sait linkin.',
    errorCode: 'Virhekoodi: {code}',
  },
};

export default fi;
